import github from "./github-footer.svg";

export default function Footer() {
  return (
    <div className="Footer">
      <p>Created and Designed By Siddharth Varangaonkar.{"    "}</p>
      <a
        href="https://github.com/sidv1905"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img className="footer-icon" src={github} />
      </a>
    </div>
  );
}
